import { useState } from "react";

type Props = {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  required?: boolean;
  placeholder?: string;
  autoFocus?: boolean;
};

/** Password input with show/hide eye toggle. */
export function PasswordField({
  id,
  label,
  value,
  onChange,
  autoComplete,
  required,
  placeholder,
  autoFocus,
}: Props) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="sp-field">
      <label htmlFor={id}>{label}</label>
      <div className="sp-password-wrap">
        <input
          id={id}
          type={visible ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          required={required}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
        <button
          type="button"
          className="sp-password-toggle"
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
}
